import cn from 'classnames'
import { memo } from 'react'

import { IProgressTrackProps } from './models'

import styles from './ProgressTrack.module.scss'

/**
 * Created by plexideas on 03.05.23
 */
export const ProgressTrack = memo<IProgressTrackProps>(
  ({
    status,
    direction,
    color,
    variant,
    size,
    highlightCompletedStep = false,
    withTrackGap = true,
    fullWidth = false,
    inlineVertical = false,
    fromCurrentStep = false,
  }) => {
    const isVertical = direction === 'vertical'

    return (
      <div
        className={cn(
          styles.track,
          styles[status],
          styles[color],
          styles[variant],
          styles[`size${size}`],
          { [styles.withoutGap]: !withTrackGap },
          { [styles.fullWidth]: fullWidth && !isVertical },
          { [styles.inlineVertical]: inlineVertical && isVertical },
          { [styles.fromCurrentStep]: fromCurrentStep },
          { [styles.highlightCompletedStep]: highlightCompletedStep },
          {
            [styles.vertical]: isVertical,
          }
        )}
      />
    )
  }
)

ProgressTrack.displayName = 'ProgressTrack'
